import { OperationDetails } from '~/routes/production_planning_pages/operations/types';
import { getAuthToken } from '~/utils/auth';

import { formatTimeInMinutes } from '../helpers';

export const updateOperation = async (
  newOperationVersion: OperationDetails | undefined,
): Promise<boolean> => {
  if (!newOperationVersion) return false;
  const operation = {
    partner_name: newOperationVersion.partner_name,
    update_bills_of_operations: true,
    operation_name: newOperationVersion.operation_name,
    operation_headcount: newOperationVersion.operation_headcount ?? undefined,
    operation_work_time: formatTimeInMinutes(newOperationVersion.operation_work_time as string),
    operation_pre_flight_checks: newOperationVersion.operation_pre_flight_checks,
    operation_in_process_checks: newOperationVersion.operation_in_process_checks,
    operation_category: newOperationVersion.operation_category ?? undefined,
    operation_sub_category: newOperationVersion.operation_sub_category ?? undefined,
    operation_partner_label: newOperationVersion.operation_partner_label ?? undefined, // Add this line
    operation_tags: newOperationVersion.operation_tags ?? undefined,
    is_archived: newOperationVersion?.operations?.is_archived ?? false,
    is_final: newOperationVersion?.operations?.is_final ?? false,
    operation_versions_config: newOperationVersion?.operation_versions_config,
  };
  const response = await fetch(
    `${import.meta.env.VITE_TRUNK_BACKEND_URL}/operations/${newOperationVersion.operation_id}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ${getAuthToken() ?? ''}`,
      },
      body: JSON.stringify(operation),
    },
  );
  if (!response.ok) {
    throw new Error('Failed to update operation');
  }

  return await response.json();
};

export const updateClonedOperations = async ({
  partnerName,
  operationsIds,
  properties,
}: {
  partnerName: string;
  operationsIds: string[];
  properties: OperationDetails;
}) => {
  if (properties?.operation_work_time) {
    properties.operation_work_time = formatTimeInMinutes(properties.operation_work_time as string);
  }

  // Bulk update operations
  const response = await fetch(`${import.meta.env.VITE_TRUNK_BACKEND_URL}/operations/bulk-update`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${getAuthToken() ?? ''}`,
    },
    body: JSON.stringify({
      operation_ids: operationsIds,
      details: {
        ...properties,
        partner_name: partnerName,
      },
    }),
  });
  return await response.json();
};
